// Like `ToggleControl`, but the toggle is prefixing the label.
import React from 'react';
import { styled } from '@linaria/react';

import Toggle, { Props as ToggleProps } from '@/components/Toggle';

export interface Props
  extends Omit<ToggleProps, 'handleToggle' | 'active'> {
  id: string;
  label: string;
  value: boolean;
  setValue: (value: boolean) => void;
  gridArea?: string;
  wrapperStyle?: React.CSSProperties;
}

function InlineToggleControl({
  id,
  label,
  value,
  setValue,
  gridArea = '',
  wrapperStyle = {},
  ...delegated
}: Props) {
  return (
    <Wrapper style={{ '--grid-area': gridArea, ...wrapperStyle }}>
      <Toggle
        id={id}
        active={value}
        handleToggle={() => {
          setValue(!value);
        }}
        {...delegated}
      />
      <Label htmlFor={id}>{label}</Label>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  gap: 16px;
`;

const Label = styled.label`
  font-weight: var(--font-weight-medium);
  user-select: none;
  font-size: 1rem;
`;

export default InlineToggleControl;
